import { Card } from '@components/atoms/Card';
import { FormGroup } from '@components/molecules/form/FormGroup';
import ReactSelect from '@components/atoms/ReactSelect';

export const SelectGroup = () => {
  return (
    <Card>
      <div className="flex flex-col gap-4 ">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Selects
        </h2>
        <div className="flex flex-col">
          <ReactSelect
            isMulti
            isLoading
            isDisabled
            isClearable
            isSearchable
            options={[]}
            placeholder="Add a new client"
          />
          <div className="flex flex-col gap-4 mt-6">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">
              Selects with options and FormGroup
            </h2>
            <div className="grid grid-cols-2 gap-4">
              <FormGroup
                label="Client Name"
                htmlFor="clientName"
                error="Client name is required">
                <ReactSelect
                  error
                  isMulti
                  isClearable
                  isSearchable
                  options={[
                    { label: 'Option 1', value: 'option1' },
                    { label: 'Option 2', value: 'option2' },
                    { label: 'Option 3', value: 'option3' },
                  ]}
                  placeholder="Add a new client"
                />
              </FormGroup>
              <FormGroup label="Client Name" htmlFor="clientName2">
                <ReactSelect
                  isMulti
                  isClearable
                  isSearchable
                  options={[
                    { label: 'Option 1', value: 'option1' },
                    { label: 'Option 2', value: 'option2' },
                    { label: 'Option 3', value: 'option3' },
                  ]}
                  placeholder="Add a new client"
                />
              </FormGroup>
            </div>

            <div className="flex flex-col gap-4 mt-6">
              <FormGroup label="Client Name" htmlFor="clientName">
                <ReactSelect
                  isClearable
                  isSearchable
                  options={[
                    { label: 'Option 1', value: 'option1' },
                    { label: 'Option 2', value: 'option2' },
                    { label: 'Option 3', value: 'option3' },
                  ]}
                  placeholder="Add a new client"
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
